import { Button, Group, Select, Text } from "@mantine/core";
import React, { useState } from "react";
import { useServerApi } from "../hooks/userServerApi";
import { DatePicker } from "@mantine/dates";
import { useTranslation } from "react-i18next";
import { DATA_INCENTIVE_TYPE } from "../data/options";
import { openFileUrl } from "../utils/openReport";

const TYPE_FILTER_OPTIONS = [
  { label: "All Types", value: "" },
  ...DATA_INCENTIVE_TYPE,
];

const ReportIncentiveCharge = () => {
  const [loading, setLoading] = useState(false);
  const [api] = useServerApi();
  const { t } = useTranslation();
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [incentiveType, setIncentiveType] = useState("");

  const downloadReport = async () => {
    try {
      setLoading(true);
      const result = await api.Incentive.getReport({
        fromDate,
        toDate,
        incentiveType: incentiveType || undefined,
      });
      setLoading(false);

      if (result?.url) {
        await openFileUrl(result.url);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <div>
      <Text size="xs">
        {t(
          "Please enter the issue date period for incentive and charge records"
        )}
      </Text>
      <Group mt="xs">
        <DatePicker
          title={t("From Date")}
          size="xs"
          allowFreeInput
          placeholder="From"
          value={fromDate}
          onChange={setFromDate}
        />
        ~
        <DatePicker
          title={t("To Date")}
          size="xs"
          allowFreeInput
          placeholder="To"
          value={toDate}
          onChange={setToDate}
        />
        <Select
          title={t("Type")}
          size="xs"
          data={TYPE_FILTER_OPTIONS.map((option) => ({
            ...option,
            label: t(option.label),
          }))}
          value={incentiveType}
          onChange={setIncentiveType}
          clearable={false}
        />
      </Group>

      <Button
        size="xs"
        mt="xl"
        onClick={downloadReport}
        loading={loading}
        disabled={!fromDate || !toDate}
      >
        {t("Download")}
      </Button>
    </div>
  );
};

export default ReportIncentiveCharge;
